import React from 'react';
import SaleBaseGame from './SaleBaseGame';
function AuctionHouseGame() {
  return <SaleBaseGame saleType="Auction" />;
}

export default AuctionHouseGame;
